import { useEffect, useState } from "react"
import redirectURL from "../redirectURL";
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import Select from "react-select";
import 'ag-grid-enterprise'
import SweetAlert from "react-bootstrap-sweetalert";
import { Modal } from 'react-bootstrap';
import { ToggleSwitch } from "./ToggleSwitch";
import Edit from "./edit.js";
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import Info from '../../assets/icons/info.png'
import Delete from "./delete.js";
import { getDDMMMYYYYHHMMDefault } from "../common/utils.js";

const Users = () => {

    const [loadData, setLoadData] = useState([])
    const [fName, setFName] = useState('')
    const [lName, setLName] = useState('')
    const [isEditMode, setIsEditMode] = useState(false);
    const [role, setRole] = useState('')
    const [dealerOptions, setDealerOptions] = useState([])
    const [plantOptions, setPlantOptions] = useState([])
    const [traansporterOptions, setTraansporterOptions] = useState([])
    const [userCode, setUserCode] = useState('')
    const [email, setEmail] = useState('')
    const [mobileNumber, setMobileNumber] = useState('');
    const [addUserModal, setAddUserModal] = useState(false);
    const [show, setShow] = useState(false)
    const [title, setTitle] = useState('')
    const [type, setType] = useState('default')
    const [editModal, setEditModal] = useState(false)
    const [overlay, setOverlay] = useState("show-n")
    const [sliderLoader, setSliderLoader] = useState("show-n")
    const [loadshow, setLoadShow] = useState("show-n")
    const [showAddSlider, setshowAddSlider] = useState("");
    var [sliderText, setSliderText] = useState("");
    const [roleOptions , setRoleOptions] = useState()

    const defaultColDef = {
        sortable: true,
        filter: true,
        resizable: true,
    }

    const columnDefs = [
        {
            headerName: "",
            field: "_id",
            width: 80,
            cellRendererSelector: function (param) {
                try {
                    if (param.data._id !== null && param.data._id !== undefined) {
                        return {
                            component: Edit,
                            params: {
                                openEditModal: openEditModal
                            }
                        }
                    }
                } catch (err) {
                    console.log(err);
                }
            },
            cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
        },
        {
            headerName: "",
            field: "_id",
            width: 80,
            cellRendererSelector: function (param) {
                try {
                    if (param.data._id !== null && param.data._id !== undefined) {
                        return {
                            component: Delete,
                            params: {
                                openDeleteRecord: openDeleteRecord
                            }
                        }
                    }
                } catch (err) {
                    console.log(err);
                }
            },
            cellStyle: { display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }
        },
        {
            headerName: "First Name",
            field: "firstname",
        },
        {
            headerName: "Last Name",
            field: "lastname",
        },
        {
            headerName: "Email ID",
            field: "email",
        },
        {
            headerName: "Role",
            field: "role",
            width: 84,
            valueGetter: function(params){
                return params?.data?.role?.[0];
            }
        },
        {
            headerName: "Code",
            field: "dealer_code",
            width: 110,
            valueGetter: function (params) {
                if (params.data?.role?.includes("DEALER")) {
                    return params.data.dealer_code;
                }
                else if (params.data?.role?.includes("PLANT")) {
                    return params.data.plant_codes;
                }
                else {
                    return "N/A";
                }
            }
        },
        {
            headerName: "Last Logged In At",
            field: "action_by",
            width: 150,
            valueGetter: function (params) {
                if (params.data?.action_date !== null & params.data?.action_date !== undefined) {
                    return getDDMMMYYYYHHMMDefault( params.data.action_date);
                }
                else {
                    return "N/A";
                }
            }
            
        },
        {
            headerName: "Status",
            field: "isactive",
            cellRendererSelector: function (param) {
                try {
                    if (param.data.isactive != null && param.data.isactive != undefined) {
                        return {
                            component: ToggleSwitch,
                            params: {
                                toggleStatus: toggleStatus
                            }
                        }
                    }
                } catch (err) {
                    console.log(err);
                }
            },
        },
    ]


    const toggleStatus = async (params) => {
        let message = ''
        if (params.isactive == 1)
            message = `Are you sure you want to de-activate ${params.email}?`
        else
            message = `Are you sure you want to activate ${params.email}?`
        if (window.confirm(message)) {
            await redirectURL.post("/switchStatus", { email: params.email })
                .then(res => {
                    if (res.data.status == "success") {
                        setTitle(res.data.message)
                        setType("success")
                        setShow(true)
                    }
                    else {
                        setTitle("Failed please try later")
                        setType("danger")
                        setShow(true)
                    }
                })
                .catch(err => console.log(err))
        } else {
            // Do nothing!
        }
    }

    function openEditModal(params) {
        setshowAddSlider("slider-translate-30p")
        setOverlay("show-m")
        setSliderText("Edit User")
        setIsEditMode(true)
        setFName(params.firstname)
        setLName(params.lastname)
        setEmail(params.email)

        setRole(roleOptions.find(e => e.value == params.role[0]))
        if (params.role[0] == "DEALER")
            setUserCode(dealerOptions.find(e => e.value == params.dealer_code))
        else if (params.role[0] == "TRANSPORTER")
            setUserCode(traansporterOptions.find(e => e.value == params.transporter_code))
        else if (params.role[0] == "PLANT")
            setUserCode(plantOptions.filter(e => params.plant_codes.find(e2 => e2 == e.value) != undefined))
    }

    async function openDeleteRecord(params) {
        let message = `Are you sure you want to delete user ${params.email}?`
        if (window.confirm(message)) {
            let body = {
                "userid": params._id,
                "email": params.email
            }
            await redirectURL.post("/deleteUserData", body)
                .then(res => {
                    if (res.data.status === "success") {
                        setTitle(res.data.message)
                        setType("success")
                        setShow(true)
                    }
                    else {
                        setTitle(res.data.message)
                        setType("danger")
                        setShow(true)
                    }
                })
                .catch(err => console.log(err))

        }
    }

    function openAddModal(params) {
        setshowAddSlider("slider-translate-30p")
        setOverlay("show-m")
        setSliderText("Add User")
        setIsEditMode(false)
    }

    const handleEditSubmit = (e) => {
        e.preventDefault()
        let body = {
            name: fName,
            role: role.value,
            email: email,
            mobileNumber: mobileNumber,
        }
        redirectURL.post("/editUserData", body)
            .then(res => {
                if (res.data.status === "success") {
                    setTitle(res.data.message)
                    setType("success")
                    setShow(true)
                    setEditModal(false)
                    setFName('')
                    setRole('')
                    setEmail('')
                    setMobileNumber('')
                }
                else {
                    setTitle(res.data.message)
                    setType("danger")
                    setShow(true)
                }
            })
            .catch(err => console.log(err))
    }

    useEffect(() => {
        getData()
    }, [])

    const getData = async () => {
        setOverlay("show-m")
        setLoadShow("show-m")
        redirectURL.post("/getExcludeEnmovilUsers", {})
            .then(response => {
                if (response.data.status === "success") {
                    setLoadData(response.data.data)
                }
            })
            .catch(err => console.log(err))
        await redirectURL.post('/getDealerDetails', {})
            .then(response => {
                if (response.data.status === "success") {
                    if (response.data.records.length > 0) {
                        let temp = response.data.records.map(e => { return { label: (e.consignee_name + " (" + e.consignee_code + ")"), value: e.consignee_code } })
                        setDealerOptions(temp);
                    }
                }
            })
            .catch(error => console.error('Error fetching data:', error));

        await redirectURL.get('consignments/getConsigner', {})
            .then(response => {
                setPlantOptions(response.data.records)
            })
            .catch(error => console.error('Error fetching data:', error));

        await redirectURL.post('/transporterlist', {})
            .then(response => {
                if (response.data.status === "success") {
                    let temp = response.data.records.map(e => { return { label: (e.transporter_name + " (" + e.transporter_code + ")"), value: e.transporter_code } })
                    setTraansporterOptions(temp);
                    setLoadShow("show-n")
                    setOverlay("show-n")
                }
            })
            .catch(error => {
                console.error('Error fetching data:', error)
                setLoadShow("show-n")
                setOverlay("show-n")
            });
            await redirectURL.post('/getroles' , {})
            .then(response =>{
                if(response.data.status == "success"){
                    const rolesArray = response.data.data || [];
                    const roles = rolesArray.map(e => ({ label: e, value: e }));
                    setRoleOptions(roles)
                }
            })
    }

    const onCellClicked = () => {

    }

    const handleSaveSubmit = async (event) => {
        event.preventDefault()
        setSliderLoader("show-m")
        try {
            if (isEditMode) {
                let query = {
                    first_name: fName,
                    last_name: lName,
                    email: email,
                    user_type: role.value
                }
                if (Array.isArray(userCode)) {
                    query["user_code"] = userCode.map(e => e.value)
                }
                else
                    query["user_code"] = userCode.value
                redirectURL.post("/editUsersData", query)
                    .then(response => {
                        if (response.data.status === 'success') {
                            setTitle(response.data.message)
                            setSliderLoader("show-n")
                            setType("success")
                            setShow(true)
                            setshowAddSlider('')
                            setFName('')
                            setLName('')
                            setEmail('')
                            setRole('')
                            setUserCode('')
                            setIsEditMode(false)
                        }
                        else if (response.data.status === "fail") {
                            setTitle(response.data.message)
                            setType("danger")
                            setShow(true)
                            setSliderLoader("show-n")
                        }
                        else {
                            setTitle("Failed to add user. Please try later")
                            setType("danger")
                            setShow(true)
                            setSliderLoader("show-n")
                        }
                    })
                    .catch(err => {
                        console.log(err)
                        setSliderLoader("show-n")
                    })
            }
            else {
                let query = {
                    first_name: fName,
                    last_name: lName,
                    email: email.toLocaleLowerCase(),
                    user_type: role.value
                }
                if (Array.isArray(userCode)) {
                    query["user_code"] = userCode.map(e => e.value)
                }
                else
                    query["user_code"] = userCode.value
                redirectURL.post("/saveUsersData", query)
                    .then(response => {
                        if (response.data.status === 'success') {
                            setTitle(response.data.message)
                            setSliderLoader("show-n")
                            setType("success")
                            setShow(true)
                            setshowAddSlider('')
                            setFName('')
                            setLName('')
                            setEmail('')
                            setRole('')
                            setUserCode('')
                            setIsEditMode(false)
                        }
                        else if (response.data.status === "fail") {
                            setTitle(response.data.message)
                            setType("danger")
                            setShow(true)
                            setSliderLoader("show-n")
                        }
                        else {
                            setTitle("Failed to add user. Please try later")
                            setType("danger")
                            setShow(true)
                            setSliderLoader("show-n")
                        }
                    })
                    .catch(err => {
                        console.log(err)
                        setSliderLoader("show-n")
                    })
            }
        } catch (er) {
            setSliderLoader("show-n")
        }
    };

    const onConfirm = () => {
        setShow(false)
        setLoadShow("show-n")
        setOverlay("show-n")
        setTitle('')
        setType('default')
        setshowAddSlider('')
        setFName('')
        setLName('')
        setEmail('')
        setRole('')
        setUserCode('')
        setIsEditMode(false)
        getData()
    };

    const hideAll = () => {
        setOverlay("show-n")
        setLoadShow("show-n")
        setshowAddSlider('')
        setFName('')
        setLName('')
        setEmail('')
        setRole('')
        setUserCode('')
        setIsEditMode(false)
    };

    return (
        <>
            <SweetAlert
                show={show}
                title={<span style={{ fontSize: "1rem" }}>{title}</span>}
                onConfirm={onConfirm}
                confirmBtnBsStyle={type}
                confirmBtnCssClass="sweetButton"
                customClass='sweetWidth'
                type={type}>
            </SweetAlert>
            <div className="col-lg-12 d-flex justify-content-between align-items-center" style={{ marginTop: "20px" }}>
                <div style={{ display: "flex" }}><i className="fa fa-building-o cus-i"></i>&nbsp;&nbsp;<span style={{ fontWeight: "600" }}>User Management</span></div>
                <div>
                    <button className="btn btn-warning" onClick={openAddModal}>
                        <i className="icon-plus"></i>&nbsp;Add User
                    </button>
                </div>
            </div>
            <div className="row mt-10p">
                <div className="col-xl-12 col-lg-12">
                    <div className="card">
                        <div className="card-body pt-10px" >
                            <div className={"ag-theme-balham mt-8"} style={{ height: '500px', width: '100%', paddingTop: "1rem" }}>
                                <AgGridReact
                                    columnDefs={columnDefs}
                                    rowData={loadData}
                                    defaultColDef={defaultColDef}
                                    pagination={true}
                                    paginationPageSize={50}
                                    enableRangeSelection={true}
                                    enableCellContextMenu={true}
                                    masterDetail={true}
                                    onCellClicked={onCellClicked}
                                    sideBar={{
                                        toolPanels: [
                                            {
                                                id: "columns",
                                                labelDefault: "Columns",
                                                labelKey: "columns",
                                                iconKey: "columns",
                                                toolPanel: "agColumnsToolPanel",
                                                toolPanelParams: {
                                                    suppressPivotMode: true,
                                                    suppressRowGroups: true,
                                                    suppressValues: true,
                                                }
                                            },
                                            {
                                                id: "filters",
                                                labelDefault: "Filters",
                                                labelKey: "filters",
                                                iconKey: "filter",
                                                toolPanel: "agFiltersToolPanel"
                                            }
                                        ]
                                    }}
                                    statusBar={{
                                        statusPanels: [
                                            {
                                                statusPanel: "agTotalAndFilteredRowCountComponent",
                                                align: "left"
                                            },
                                            {
                                                statusPanel: "agTotalRowCountComponent",
                                                align: "center"
                                            },
                                            { statusPanel: "agFilteredRowCountComponent" },
                                            { statusPanel: "agSelectedRowCountComponent" },
                                            { statusPanel: "agAggregationComponent" }
                                        ]
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className={"overlay-part " + overlay} onClick={hideAll}></div>
                { showAddSlider && <div className={"slide-r " + showAddSlider} onClick={(e) => e.stopPropagation()}>
                    <div className="slide-r-title">
                        <h4 className="">{sliderText}
                            <span className="float-right closebtn" style={{ marginRight: "25px" }} onClick={hideAll}>X</span>
                        </h4>
                    </div>
                    <div className="slide-r-body">
                        <div className={"dataLoad " + (sliderLoader)} style={{ opacity: "0.5" }}>
                            <div style={{ position: "fixed", left: "50%", top: '50%' }}>
                                <div class="loader-box">
                                    <div class="loader-box">
                                        <div class="rotate dashed colored"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <form className="" style={{ padding: "20px" }} onSubmit={handleSaveSubmit}>
                            <div className="form-group">
                                <label style={{ display: "block", marginBottom: "5px" }}>
                                    <span style={{ color: "#EB1D54", fontSize: "13px" }}>*</span>&nbsp;First Name
                                </label>
                                <input
                                    type="text"
                                    value={fName}
                                    style={{
                                        width: "100%",
                                        padding: "10px",
                                        border: "1px solid #ccc",
                                        borderRadius: "4px",
                                    }}
                                    onChange={e => setFName(e.target.value)}
                                    autoComplete='off'
                                    required
                                />
                            </div>
                            <div className="form-group">
                                <label style={{ display: "block", marginBottom: "5px" }}>
                                    <span style={{ color: "#EB1D54", fontSize: "13px" }}>*</span>&nbsp;Last Name
                                </label>
                                <input
                                    type="text"
                                    value={lName}
                                    onChange={e => setLName(e.target.value)}
                                    autoComplete='off'
                                    required
                                    style={{
                                        width: "100%",
                                        padding: "10px",
                                        border: "1px solid #ccc",
                                        borderRadius: "4px",
                                    }}
                                />
                            </div>
                            {
                                isEditMode ?
                                    <div className="form-group">
                                        <label style={{ display: "block", marginBottom: "5px" }}>
                                            <span style={{ color: "#EB1D54", fontSize: "13px" }}>*</span>&nbsp;Email&nbsp;
                                        </label>
                                        <input
                                            type="email"
                                            value={email}
                                            style={{
                                                width: "100%",
                                                padding: "10px",
                                                border: "1px solid #ccc",
                                                borderRadius: "4px",
                                                backgroundColor: "#e7e7e7",
                                            }}
                                            // onChange={e => setEmail(e.target.value)}
                                            readOnly
                                        />
                                    </div>
                                    : <div className="form-group">
                                        <label style={{ display: "block", marginBottom: "5px" }}>
                                            <span style={{ color: "#EB1D54", fontSize: "13px" }}>*</span>&nbsp;Email&nbsp;
                                            <OverlayTrigger
                                                placement="top"
                                                overlay={<Tooltip id="tooltip-example">The password will be sent to email.</Tooltip>}>
                                                <img src={Info} width="16px" style={{ position: "absolute" }} />
                                            </OverlayTrigger>
                                        </label>
                                        <input
                                            type="email"
                                            value={email}
                                            style={{
                                                width: "100%",
                                                padding: "10px",
                                                border: "1px solid #ccc",
                                                borderRadius: "4px",
                                            }}
                                            onChange={e => setEmail(e.target.value)}
                                            required
                                        />
                                    </div>
                            }
                            <div className="form-group">
                                <label style={{ display: "block", marginBottom: "5px" }}>
                                    <span style={{ color: "#EB1D54", fontSize: "13px" }}>*</span>&nbsp;User Role
                                </label>
                                <Select
                                    className="border-radius-0"
                                    isMulti={false}
                                    value={role}
                                    id="selectedFilter"
                                    style={{ borderRadius: "0px" }}
                                    onChange={e => setRole(e)}
                                    options={roleOptions}
                                />
                            </div>
                            {
                                (role.hasOwnProperty("value") && role.value == "DEALER") ?
                                    <div className="form-group">
                                        <label style={{ display: "block", marginBottom: "5px" }}>
                                            <span style={{ color: "#EB1D54", fontSize: "13px" }}>*</span>&nbsp;Dealer Location
                                        </label>
                                        <Select
                                            className="border-radius-0"
                                            isMulti={false}
                                            value={userCode}
                                            id="selectedFilter"
                                            style={{ borderRadius: "0px" }}
                                            onChange={e => setUserCode(e)}
                                            options={dealerOptions}
                                        />
                                    </div> : <></>
                            }
                            {
                                (role.hasOwnProperty("value") && role.value == "PLANT") ?
                                    <div className="form-group">
                                        <label style={{ display: "block", marginBottom: "5px" }}>
                                            <span style={{ color: "#EB1D54", fontSize: "13px" }}>*</span>&nbsp;Plant Location
                                        </label>
                                        <Select
                                            className="border-radius-0"
                                            isMulti={true}
                                            value={userCode}
                                            id="selectedFilter"
                                            style={{ borderRadius: "0px" }}
                                            onChange={e => setUserCode(e)}
                                            options={plantOptions}
                                        />
                                    </div> : <></>
                            }
                            <div className="form-group" style={{ textAlign: "center" }}>
                                <button type="submit" className="btn btn-success"
                                    style={{
                                        padding: "10px 20px",
                                        border: "none",
                                        borderRadius: "4px",
                                    }}
                                >Submit
                                </button>
                            </div>
                        </form>
                    </div>
                </div>}
                <div className={"overlay-part " + (overlay)} style={{ zIndex: "10" }}
                    onClick={hideAll}
                ></div>
                <div className={"dataLoadpage " + (loadshow)}></div>
                <div className={"dataLoadpageimg " + (loadshow)} style={{ top: "21em" }}>
                    <div className="loader-box"><div className="loader-box"><div className="rotate dashed colored"></div></div></div>
                </div>
            </div>
        </>
    )
}

export default Users